import React from 'react';

import { FormComponent } from 'components';
import { SearchEventFilterType } from 'types';

interface Props {
  handleFilter: (filter: SearchEventFilterType) => void;
}

function Filter({ handleFilter }: Props) {
  return (
    <FormComponent.Form submit={handleFilter}>
      <FormComponent.SearchInput
        name="title"
        placeholder="봉사명으로 검색해주세요"
      />
    </FormComponent.Form>
  );
}

export default Filter;
